import Line from './Line';
import Circle from './Circle';

export {
  Line,
  Circle,
};

export default {
  Line,
  Circle,
};
